import { transparentize } from 'polished'
import styles from './Spinner.module.css'

export interface SpinnerProps {
  color?: string
  size?: number
  thickness?: number
}

/**
 * A spinning loading indicator.
 */
export function Spinner({
  color = 'var(--theme-base)',
  size = 24,
  thickness = 2,
}: SpinnerProps) {
  const offColor =
    // `transparentize` can't resolve CSS variables, so the theme color uses
    // its predefined light tint instead.
    color === 'var(--theme-base)'
      ? 'var(--theme-lighten)'
      : transparentize(0.8, color)
  return (
    <div className={styles.root}>
      <div
        className={styles.icon}
        style={{
          borderColor: offColor,
          borderTopColor: color,
          width: size,
          height: size,
          borderWidth: thickness,
        }}
      />
    </div>
  )
}
